class DiscountCodeForm extends HTMLElement {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.onDeleteDiscount = this.onDeleteDiscount.bind(this);
  }

  connectedCallback() {
    this.submitBtn = this.querySelector('.cart__field--discount-submit');
    this.inputField = this.querySelector('.cart__field--discount');
    this.deleteDiscountBtns = this.querySelectorAll('.cart__field--discount-delete');
    this.applicableDiscountsInput = this.querySelector('.cart__field--discounts-applied');
    this.applicableDiscounts = [];
    this.discountCodes = JSON.parse(this.dataset.discounts);

    try {
      this.config = JSON.parse(this.dataset.config || '{}');
    } catch (e) {
      console.error('Error parsing discount config:', e);
      this.config = {};
    }

    if (this.config) {
      this.enableGwp = this.config.enable_gwp_with_discount;
      this.cartDiscountCode = this.config.cart_discount_code;
      this.gwpDiscountProduct = this.config.gwp_discount_product;
      this.cartItems = this.dataset.cartItems ? JSON.parse(this.dataset.cartItems) : [];
    }

    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', this.onSubmit);
    }
    if (this.deleteDiscountBtns.length) {
      this.deleteDiscountBtns.forEach(btn => {
        btn.addEventListener('click', this.onDeleteDiscount);
      });
    }

    this.applyDiscounts();
    if(this.enableGwp) {
      this.handleGWP();
    }
  }

  disconnectedCallback() {
    if (this.submitBtn) {
      this.submitBtn.removeEventListener('click', this.onSubmit);
    }
    if (this.deleteDiscountBtns && this.deleteDiscountBtns.length) {
      this.deleteDiscountBtns.forEach(btn => {
        btn.removeEventListener('click', this.onDeleteDiscount);
      });
    }
  }

	formatMoney(cents, currency = '$') {
		return currency + (cents / 100).toFixed(2);
	}

	updateCartUI(cart) {
		// ---------- Subtotal ----------
		const subtotalEl = document.querySelector('[data-cart-total]');
		if (subtotalEl) {
			if (cart.original_total_price === 0) {
				subtotalEl.textContent = 'Free';
			} else {
				subtotalEl.textContent = this.formatMoney(cart.original_total_price);
			}

			// показ/ховання subtotal
			const cartTotalBlock = subtotalEl.closest('.cart__total');
			if (cartTotalBlock) {
				if (cart.original_total_price === 0) {
					cartTotalBlock.classList.add('hidden');
				} else {
					cartTotalBlock.classList.remove('hidden');
				}
			}
		}

		// ---------- Discounts ----------
		const discountContainer = document.querySelector('.cart__discounts');
		if (!discountContainer) return;

		discountContainer.innerHTML = ''; // очищаємо
		if (cart.cart_level_discount_applications.length > 0) {
			discountContainer.classList.remove('hidden');
			cart.cart_level_discount_applications.forEach(discount => {
				const div = document.createElement('div');
				div.className = 'cart__total';
				div.innerHTML = `
        <span>${discount.title}</span>
        <span>- ${this.formatMoney(discount.total_allocated_amount)}</span>
      `;
				discountContainer.appendChild(div);
			});
		} else {
			discountContainer.classList.add('hidden');
		}
	}


	onSubmit(event) {
		event.preventDefault();
		let discounts = this.applicableDiscounts.slice();
		let newCode = this.inputField.value.trim();

		if (!newCode) {
			this.showMessage('Please enter a discount code.');
			return;
		}
		if (!discounts.includes(newCode)) discounts.push(newCode);
		else {
			this.showMessage('This discount code is already applied.');
			return;
		}

		const discountString = discounts.join(',');
		fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ discount: discountString })
		})
			.then(res => res.json())
			.then(() => window.cart.getCart())
			.then(() => window.cart.getCart())
			.then(cart => {
				if (!cart || !cart.discount_codes) {
					return;
				}

				this.applicableDiscounts = cart.discount_codes.map(dc => dc.code);
				this.applicableDiscountsInput.value = this.applicableDiscounts.join(',');
				// this.updateCartUI(cart);

				this.showMessage('Discount code applied successfully!');
			})
			.catch(err => {
				console.error(err);
			});

	}

	onDeleteDiscount(event) {
		const codeToRemove = event.currentTarget.getAttribute('data-discount-id');
		let discounts = this.applicableDiscounts.filter(code => code !== codeToRemove);
		const discountString = discounts.join(',');

		fetch(window.Shopify.routes.root + 'cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ discount: discountString })
		})
			.then(res => res.json())
			.then(() => window.cart.getCart())
			.then(cart => {
				this.applicableDiscounts = cart.discount_codes.map(dc => dc.code);
				this.applicableDiscountsInput.value = this.applicableDiscounts.join(',');
				this.updateCartUI(cart);
			})
			.catch(err => {
				console.error(err);
				this.showMessage('Error removing discount.');
			});
	}


  onDeleteDiscount(event) {
    const codeToRemove = event.currentTarget.getAttribute('data-discount-id');

    let discounts = this.applicableDiscounts.filter(code => code !== codeToRemove);
    
    const discountString = discounts.join(',');

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: discountString })
    })
    .then(response => response.json())
    .then(() => {
      window.cart.getCart();
    })
    .catch((error) => {
      console.error('Error:', error);
      this.showMessage('An error occurred while removing the discount.');
    });
  }

  handleGWP() {
    const hasGWP = Array.isArray(this.cartItems) && 
      this.cartItems.some(item => 
        String(item.variant_id) === String(this.gwpDiscountProduct) && item.properties['_Free gift'] === 'yes');

    const hasGWPCode = this.applicableDiscounts.includes(this.cartDiscountCode);

    if (hasGWPCode && !hasGWP) {
      window.cart.updateCartWithGiftProduct(this.gwpDiscountProduct, 1, 'add');
    } 
    else if (!hasGWPCode && hasGWP) {
      const giftLineItem = this.cartItems.find(
        item =>
          String(item.variant_id) === String(this.gwpDiscountProduct) &&
          item.properties &&
          item.properties['_Free gift'] === 'yes'
      );

      window.cart.updateCartWithGiftProduct(giftLineItem.key, 0, 'update');
    }
  }

  applyDiscounts() {
    this.applicableDiscounts = this.discountCodes.filter(dc => dc.applicable).map(dc => dc.code);

    if (this.applicableDiscounts.length > 0) {
      this.applicableDiscountsInput.value = this.applicableDiscounts.join(',');
    }
  }

  showMessage(msg) {
    const discountBox = this.closest('.cart-drawer__discount-code');
    if (discountBox) {
      const prevMsg = discountBox.querySelector('.cart-drawer__discount-message');
      if (prevMsg) prevMsg.remove();
      let p = document.createElement('p');
      p.className = 'cart-drawer__discount-message';
      p.textContent = msg;
      discountBox.appendChild(p);
    }
  }
}

customElements.define('discount-code-form', DiscountCodeForm);